<template>
    <div class="columns">
        <div class="column is-8">
            <div class="medium-container">
                <div
                    ref="medium"
                    v-html="data"
                    @input="result = $event.target.innerHTML"
                    class="content medium-content"
                ></div>
            </div>
        </div>
        <div class="column is-4">
            <textarea
                v-model="result"
                @change="data = result"
                class="textarea textarea-code"
                rows="24"
            ></textarea>
        </div>
    </div>
</template>

<script>
import MediumEditor from 'medium-editor';

export default {
    name: 'string-wysiwyg',
    props: {
        data: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            editor: null,
            result: this.data
        };
    },
    mounted() {
        this.editor = new MediumEditor(this.$refs.medium, {
            toolbar: {
                buttons: ['bold', 'italic', 'underline', 'orderedlist', 'unorderedlist', 'h2', 'h3', 'h4']
            }
        });
    }
};
</script>

<style lang="scss">
.medium-container {
    border: 1px solid grey;
    border-radius: 0.4em;
    padding: 0.4em;
    min-height: 400px;
    max-height: 560px;
    background-color: white;
    color: black;
    overflow-x: auto;
    overflow-y: auto;

    .medium-content {
        color: black !important;
        min-height: 400px;
        padding: 0.4em;

        * {
            color: black !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/string-wysiwyg.vue